import * as React from "react";
import { DragDropList } from "react-dragdrop-kit";
import './ReorderPlaylist.css'

export default function ReorderPlaylistComponent({
  items,
  renderItem,
  onReorder,
  gap = 8,
  showDropIndicator = true,
  className = "remove-bg-reorder-playlist",
}) {
  const handleReorder = (next, updates) => {
    const normalized = next.map((it, i) => ({ ...it, position: i }));
    onReorder(normalized, updates);
  };

  return (
    <DragDropList
      items={items}
      onReorder={handleReorder}
      renderItem={renderItem}
      showDropIndicator={showDropIndicator}
      gap={gap}
      containerClassName={className}
      itemClassName={className}
      dropIndicatorPosition="top" 
    />
  );
}
